<template>
  <li class="sortablemenu" :id="this.item.id">
    <a href="Javascript:" v-if="adminmode" v-show="state === 'default'">
      <i class="li-move fa fa-arrows-v"></i>
      <i :class="'li-icon fa '+this.item.icon"></i>
      <span class="title">{{this.item.title}}</span>
      <i v-if="adminmode" class="li-edit fa fa-edit" @click="editMode"></i>
    </a>

    <a v-else :href="'/dashboards/' + this.item.url" v-show="viewMode">
      <i :class="'li-icon fa '+this.item.icon"></i>
      <span class="title">{{this.item.title}}</span>
    </a>

    <div v-show="state === 'editing'">
      <div class="edit-buttons">
        <input v-model="data.title" placeholder="Update item" type="text" />
        <button class="update" @click="saveEdit">Update</button>
        <button class="delete" @click="deleteComment">Delete</button>
        <button class="cancel" @click="resetEdit">Cancel</button>
      </div>
    </div>
  </li>
</template>
<script>
export default {
  props: {
    item: {
      required: true,
      type: Object
    },
    adminmode: Number
  },
  data: function() {
    return {
      editable: false,
      state: "default",
      data: {
        title: this.item.title
      },
      target: ""
    };
  },
  methods: {
    editMode() {
      this.state = "editing";
    },
    viewMode() {
      this.state = "default";
    },
    resetEdit() {
      this.state = "default";
      this.data.title = this.item.content;
    },
    saveEdit() {
      this.state = "default";
      this.$emit("item-updated", {
        id: this.item.id,
        title: this.data.title
      });
    },
    deleteComment() {
      this.$emit("item-deleted", {
        id: this.item.id
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/js/components/admin/dashboardMenuItem.vue